<app-header />
<div class="app-layout">
  <aside class="sidebar surface" [class.collapsed]="isSidebarCollapsed()">
    <app-menu [collapsed]="isSidebarCollapsed()" />
    <button class="collapse-button" type="button" (click)="toggleSidebar()" [attr.aria-expanded]="!isSidebarCollapsed()">
      <span class="material-symbols-outlined">{{ isSidebarCollapsed() ? 'keyboard_double_arrow_right' : 'keyboard_double_arrow_left' }}</span>
    </button>
  </aside>

  <section class="main-content">
    <div class="content-card surface">
      <router-outlet />
    </div>
  </section>
</div>
<app-toast-container />
